import { matchesAttribute } from './matchesImageCollection';

export function findBundleProductImageCollection(
  imageCollections,
  selectedProduct
) {
  return (
    imageCollections?.find(
      (image) =>
        image.product_title?.[0] &&
        selectedProduct?.title &&
        image.product_title?.[0] === selectedProduct.title
    ) || null
  );
}

// Enhanced gallery collection matching function
export function findVariantImageCollection(
  imageCollections,
  variant,
  selectedOptions
) {
  if (!imageCollections?.length || !variant) return null;

  // Extract current variant options
  const size = selectedOptions?.size;

  // Get secondary attribute (non-Size) from variant
  let secondaryAttribute = null;
  let secondaryAttributeName = null;
  if (variant?.selectedOptions) {
    const secondaryOption = variant.selectedOptions.find(
      (option) => option?.name !== 'Size'
    );
    secondaryAttribute = secondaryOption?.value;
    secondaryAttributeName = secondaryOption?.name;
  }
  // 1. Matching: Size + Secondary Attribute combination
  if (size && secondaryAttribute) {
    const combinedMatch = imageCollections.find((collection) => {
      const sizeMatches = matchesAttribute(collection, 'Size', size);

      const secondaryMatches = matchesAttribute(
        collection,
        secondaryAttributeName,
        secondaryAttribute
      );
      return sizeMatches && secondaryMatches;
    });

    if (combinedMatch) {
      return combinedMatch;
    }
  }

  // 2. Fallback 1: Size-only match
  if (size) {
    const sizeMatch = imageCollections.find((collection) =>
      matchesAttribute(collection, 'Size', size)
    );
    if (sizeMatch) {
      return sizeMatch;
    }
  }

  // 3. Fallback 2: Secondary attribute only match
  if (secondaryAttribute && secondaryAttributeName) {
    const secondaryMatch = imageCollections.find((collection) =>
      matchesAttribute(collection, secondaryAttributeName, secondaryAttribute)
    );
    if (secondaryMatch) {
      return secondaryMatch;
    }
  }

  // 4. Return default or first collection
  const defaultImage = imageCollections.find((image) => image.default_image);
  return defaultImage || imageCollections[0];
}

// `position_in_gallery` is 1-based; slide indexes are 0-based.
export function findVideoAtSlide(collection, slideIndex) {
  return collection?.videos?.find(
    (video) => video.position_in_gallery - 1 === slideIndex
  );
}

export function getDefaultImageCollection(imageCollections) {
  if (!imageCollections?.length) return null;

  return (
    imageCollections.find((image) => image.default_image) || imageCollections[0]
  );
}
